/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AOMGH5PageLeavePlugin
 */

import { ITracker } from '@omega-tracker/core/src/com/didichuxing/tracker/ITracker';
import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import { ITrackedEventArgs } from 'com/didichuxing/tracker/plugin/IReportingStrategyPlugin';
import AReportingStrategyPlugin from 'com/didichuxing/tracker/plugin/AReportingStrategyPlugin';
import PluginUtils from 'com/didichuxing/tracker/plugin/utils/PluginUtils';
import OMGH5PageLeaveEvent from 'com/didichuxing/tracker/h5/plugins/events/OMGH5PageLeaveEvent';
import { ITrackerAdvancedContext } from 'com/didichuxing/tracker/h5/context/ITrackerAdvancedContext';

export default abstract class AOMGH5PageLeavePlugin extends AReportingStrategyPlugin {

    /**
     * @constructor
     */
    constructor(tracker: ITracker) {
        super(tracker);
        this.reportLeaveUnderHashChange = this.reportLeaveUnderHashChange.bind(this);
        this.reportLeaveUnderPopstateChange = this.reportLeaveUnderPopstateChange.bind(this);
    }

    /**
     * @override
     * @returns {string}
     */
    public getName(): string {
        return PluginUtils.PLUGIN_NAME_PAGE_LEAVE;
    }

    /**
     * hash change上报page leave
     */
    protected reportLeaveUnderHashChange(): void {
        this.reportFromLeave();
        this.getTracker().setConfig({
            url: window.location.href
        });
    }

    /**
     * popstate change上报page leave
     */
    protected reportLeaveUnderPopstateChange(): void {
        this.reportFromLeave();
        this.getTracker().setConfig({
            url: window.location.href
        });
    }

    /**
     * 离开事件上报。
     */
    protected reportFromLeave(): void {
        this.report({
            eventId: PluginUtils.EVENT_ID_PAGE_LEAVE,
            attrs: {}
        });
    }

    /**
     * @override
     * @inheritDoc
     */
    public execute(): void {
        const context: ITrackerAdvancedContext = this.getContext() as ITrackerAdvancedContext;
        if (context.hashRouterEnable) { // 监控hash history change
            window.addEventListener('hashchange', this.reportLeaveUnderHashChange);
        }
        if (context.browserRouterEnable) { // 监控browser popstate change
            window.addEventListener('popstate', this.reportLeaveUnderPopstateChange);
        }
    }

    /**
     * @override
     * @inheritDoc
     */
    public exit(): void {
        this.getTracker().setConfig({
            url: window.location.href
        });
        this.reportFromLeave();
        window.removeEventListener('hashchange', this.reportLeaveUnderHashChange);
        window.removeEventListener('popstate', this.reportLeaveUnderPopstateChange);
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITrackedEventArgs} eventArgs
     * @returns {ITrackedEvent}
     */
    protected generateEvent(eventArgs: ITrackedEventArgs): ITrackedEvent {
        return new OMGH5PageLeaveEvent(eventArgs.attrs, this.getContext());
    }
}
